import { Component, Input, OnInit } from '@angular/core';
import { AttentionInfoModel } from '@core/models/models';
import { CommonColor, KbnStatus } from '@core/constants';
import { CommonHelper } from '@core/services/common';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'caremoni-attention',
  templateUrl: './attention.component.html',
  styleUrl: './attention.component.scss'
})
export class AttentionComponent implements OnInit {
  @Input() data: AttentionInfoModel = new AttentionInfoModel();
  @Input() config: any;

  kbnText : string = "";
  textColor : string = "";
  borderStype : any = "";
  borderRadius : any = "";
  borderColor : any = "";
  labelConfig: any = {};
  status_kbn: any = 0;
  attention_flg: boolean = false;
  isCancelStatus: boolean = false;

  constructor() { }

  ngOnInit(): void {
    // set color default
    this.textColor = 'white';
    if (this.data && Array.isArray(this.data)) {
        let arrayData: any[] = CommonHelper.getArrayData(cloneDeep(this.data)) || []; 
        if (arrayData.length > 0) {
          const currentAttentionData: any[] = this.getCurrentAttentionData(arrayData) || [];
          if(currentAttentionData.length > 0) {
            this.getKbnInfo(currentAttentionData[0]);
          }
        } 
    }
    else this.getKbnInfo(this.data);
    //set label config
    this.labelConfig = { textColor: this.textColor, minWidth: '3vw', minHeight: '5.8vh', labelPosition: 'center', highlight: this.attention_flg ? true : false,
        borderStyle: this.borderStype, borderRadius: this.borderRadius, borderWidth: '1px', borderColor: this.borderColor };
  }

  getCurrentAttentionData(dataArray: any[]): any[] {
    if (!Array.isArray(dataArray) || dataArray.length === 0) return [];
    let currentMealPeriod: string | null = null;

    currentMealPeriod = CommonHelper.currentTimeInPeriod();

    if (!currentMealPeriod) return []; // Nếu không có khoảng thời gian phù hợp

    // Lọc danh sách dữ liệu thuộc khoảng thời gian bữa ăn hiện tại
    return dataArray?.filter(item => {
        const itemHour = new Date(item.date).getHours();
        const [start, end] = currentMealPeriod!?.split('～')?.map(time => parseInt(time?.split(':')[0], 10));
        return itemHour >= start && itemHour <= end;
    });
  }

  getKbnInfo(data: any) {
    if(!data) return;
    this.isCancelStatus = false;
    this.attention_flg = data.attention_flg || false;
    this.status_kbn = data.status_kbn || 0;
    if (data.attention_flg || data.status_kbn == KbnStatus.STATUS_CANCEL) this.textColor = CommonColor.ATTENTION_COLOR;;
    if (data.status_kbn == KbnStatus.STATUS_POSSIBLE) {
      this.borderStype = 'dashed';
      this.borderRadius = '6px';
    } else if (data.status_kbn == KbnStatus.STATUS_CARRY_OUT) {
      this.borderStype = 'solid';
      this.borderRadius = '6px';
    }
    switch (data.status_kbn) {
      case KbnStatus.STATUS_NO_SCHEDULE:
        this.kbnText = ""
        break;
      case KbnStatus.STATUS_SCHEDULE:
        this.kbnText = "予定"
        break;
      case KbnStatus.STATUS_POSSIBLE:
        this.kbnText = "可"
        break;
      case KbnStatus.STATUS_CARRY_OUT:
        this.kbnText = "実施"
        break;
      case KbnStatus.STATUS_CANCEL:
        this.isCancelStatus = !!this.config?.activeCancelMark;
        if (this.config?.is_training) {
          this.kbnText = "入浴<br>中止"
        } else {
          this.kbnText = "中止"
        }
        break;
    
      default:
        this.kbnText = ""
        break;
    }
  }
}